import Checkbox from '@mui/material/Checkbox';
import { Box } from '@mui/system';
import { DashboardT } from 'business/definitions';
import DashboardItemWrapper from 'modules/decision/components/DashboardItemWrapper/DashboardItemWrapper';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
    changeSelection: (slug: string) => void;
    isSelected: boolean;
    dashboard: DashboardT;
    isCurrentDashboard: boolean;
    shouldInsertChartBelow: boolean;
    toggleInsertChartBelow: () => void;
};

function AddToDashboardItem({
    changeSelection,
    isSelected,
    dashboard,
    isCurrentDashboard,
    shouldInsertChartBelow,
    toggleInsertChartBelow,
}: Props) {
    const { t } = useTranslation();
    return (
        <>
            <DashboardItemWrapper
                dataTitle={dashboard.title}
                onClick={() => {
                    changeSelection(dashboard.slug);
                }}
            >
                <Checkbox
                    data-testid={dashboard.title}
                    className="selection-checkbox"
                    defaultChecked
                    onChange={() => changeSelection(dashboard.slug)}
                    value={dashboard.slug}
                    checked={isSelected}
                />
                <div
                    className="dashboard-title"
                    onChange={() => changeSelection(dashboard.slug)}
                    role="button"
                    tabIndex={0}
                >
                    {dashboard.title}
                </div>
            </DashboardItemWrapper>
            {isCurrentDashboard && isSelected && (
                <Box sx={{ alignItems: 'center', display: 'flex', m: '10px' }}>
                    <Checkbox
                        className="selection-checkbox"
                        checked={shouldInsertChartBelow}
                        onChange={toggleInsertChartBelow}
                    />
                    <div className="dashboard-title" role="button">
                        {t('chart.insertBelowChart')}
                    </div>
                </Box>
            )}
        </>
    );
}

export default AddToDashboardItem;
